import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import VXETable from 'vxe-table'
import { store } from '@ice/stark-data'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)
import FormMaking from '@/lib/form-making-advanced'
import '@/lib/form-making-advanced/dist/FormMaking.css'
Vue.use(FormMaking)
import spin from './plugins/spin/spin'

import './bootstrap'

if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(spin)
Vue.use(VXETable)
Vue.prototype.$XPrint = VXETable.print

let router = null
let instance = null

// 主应用传值发生改变
function mainStateChange(mainState) {
  const { centerUser, platformUser, company, mainRouterPush, currentApp } = mainState
  store.set('microAppKey', currentApp.name)
  store.set('mainRouterPush', mainRouterPush)

  store.set('aUser', centerUser)
  store.set('user', platformUser)
  store.set('company', company)

  store.set('aToken', localStorage.getItem('CHOICELINK_A_TOKEN'))
  store.set('aTenantId', localStorage.getItem('CHOICELINK_A_TID'))
  store.set('bToken', localStorage.getItem('CHOICELINK_B_TOKEN'))
  store.set('bTenantId', localStorage.getItem('CHOICELINK_B_TID'))
}

function render(props = {}) {
  const { container, activeRule } = props
  router = new VueRouter({
    base: window.__POWERED_BY_QIANKUN__ ? activeRule : '/gmrmyy/',
    mode: 'hash',
    routes,
  })

  instance = new Vue({
    router,
    render: (h) => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app')
}

export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}
export async function mount(props) {
  console.log('[vue] props from main framework', props)
  mainStateChange({ ...props.mainState, currentApp: props.currentApp })
  render(props)
  props.onGlobalStateChange((state) => {
    mainStateChange(state)
  })
}
export async function unmount() {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
  router = null
}

// 独立运行时，直接挂载应用，自行注入平台及token信息
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}
